import { render } from "./SubstackCard.vue?vue&type=template&id=75743940&scoped=true&ts=true"
import script from "./SubstackCard.vue?vue&type=script&lang=ts"
export * from "./SubstackCard.vue?vue&type=script&lang=ts"

import "./SubstackCard.vue?vue&type=style&index=0&id=75743940&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75743940"]])

export default __exports__